import type { WaitingPageContent } from './waitingPageContent';
import { WAITING_PAGE_CLASS_NAMES, WAITING_PAGE_STYLE_SHEET } from './waitingPageStyles';

interface BuildWaitingPageHtmlParams extends WaitingPageContent {
    documentTitle?: string;
    lang?: string;
}

const escapeHtml = (value: string): string => (
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
);

export const buildWaitingPageHtml = ({
    documentTitle,
    lang = 'en',
    message,
    title,
}: BuildWaitingPageHtmlParams): string => {
    const safeTitle = escapeHtml(title);
    const safeMessage = escapeHtml(message);
    const safeDocumentTitle = escapeHtml(documentTitle || title);
    const safeLang = escapeHtml(lang);

    return `<!doctype html>
<html lang="${safeLang}">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>${safeDocumentTitle}</title>
  <style>${WAITING_PAGE_STYLE_SHEET}</style>
</head>
<body style="margin:0;min-height:100vh;">
  <main class="${WAITING_PAGE_CLASS_NAMES.page}" data-bustly-waiting-page aria-busy="true">
    <section class="${WAITING_PAGE_CLASS_NAMES.panel}" aria-live="polite">
      <h1 class="${WAITING_PAGE_CLASS_NAMES.title}">${safeTitle}</h1>
      <p class="${WAITING_PAGE_CLASS_NAMES.message}">${safeMessage}</p>
    </section>
  </main>
</body>
</html>`;
};
